"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPageViewEventCallbacks = createPageViewEventCallbacks;
function createPageViewEventCallbacks(contextRef) {
    return {
        community_profile_viewed: function (isOwnProfile, isLoggedIn, profileDisplayName) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('community_profile_viewed', __assign({ context: 'community', is_own_profile: isOwnProfile, is_logged_in: isLoggedIn }, (profileDisplayName && { profile_display_name: profileDisplayName })));
        },
        community_my_library_viewed: function (activeTab) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('community_my_library_viewed', {
                context: 'community',
                active_tab: activeTab,
            });
        },
        community_playlist_viewed: function (playlistId, playlistType, isOwner) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('community_playlist_viewed', {
                context: 'community',
                playlist_id: playlistId,
                playlist_type: playlistType,
                is_owner: isOwner,
            });
        },
        community_shared_playlist_viewed: function (playlistTitle, isLoggedIn) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('community_shared_playlist_viewed', {
                context: 'community',
                playlist_title: playlistTitle,
                is_logged_in: isLoggedIn,
            });
        },
    };
}
